import { Link, useNavigate } from "react-router"
import { useState } from "react"
import { Sparkle } from "lucide-react"
import { BRAND_NAME, BRAND_TAGLINE } from "../utils/config"

export default function Header(){

    const navigate = useNavigate();
    const [search, setSearch] = useState("");

    function handleSearchKeyDown(e){
        if(e.key === "Enter" && search.trim()){
            navigate(`/restaurant?search=${encodeURIComponent(search.trim())}`);
        }
    }

    return (
        <header className="bg-charcoal font-body">
            <div className="flex justify-between items-center container mx-auto py-6 px-6">
                <div className="flex items-center gap-2 text-cream">
                    <Sparkle className="w-7 h-7 text-turmeric" fill="currentColor" />
                    <span className="font-display text-2xl font-semibold tracking-tight">{BRAND_NAME}</span>
                </div>
                <Link to="/signin" className="text-cream text-sm font-medium border border-cream/30 py-2 px-5 rounded-full hover:bg-cream/10 transition">
                    Sign in
                </Link>
            </div>

            <div className="pt-10 pb-20 md:pt-16 md:pb-24">
                <div className="container mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">

                    <div>
                        <span className="inline-block text-turmeric text-xs font-mono tracking-widest uppercase mb-4">
                            ✳ Now serving Delhi
                        </span>
                        <h1 className="font-display text-4xl md:text-6xl font-semibold text-cream leading-[1.05] mb-6">
                            Food, hot off the <span className="text-turmeric">tadka</span>.
                        </h1>
                        <p className="text-cream/70 text-lg max-w-md mb-8">
                            {BRAND_TAGLINE} Real menus from restaurants near you — order the moment it's ready.
                        </p>

                        <div className="flex flex-col sm:flex-row gap-3">
                            <input
                                className="bg-cream text-charcoal text-lg px-6 py-4 rounded-xl flex-1 outline-none focus:ring-2 focus:ring-turmeric placeholder:text-charcoal/50"
                                placeholder="Search dishes, cuisines, restaurants…"
                                value={search}
                                onChange={(e)=>setSearch(e.target.value)}
                                onKeyDown={handleSearchKeyDown}
                            ></input>
                            <Link
                                to="/restaurant"
                                className="bg-ember text-cream text-lg font-medium px-8 py-4 rounded-xl text-center hover:brightness-110 transition"
                            >
                                Browse restaurants
                            </Link>
                        </div>
                    </div>

                    <div className="hidden md:flex justify-center">
                        <div className="bg-cream text-charcoal rounded-lg shadow-2xl px-8 py-7 w-80 -rotate-2 font-mono text-sm">
                            <div className="flex items-center justify-between mb-4">
                                <span className="font-semibold tracking-wide">{BRAND_NAME.toUpperCase()} TICKET</span>
                                <Sparkle className="w-4 h-4 text-ember animate-pulse" fill="currentColor" />
                            </div>
                            <div className="flex justify-between text-charcoal/60 border-t border-dashed border-charcoal/30 pt-3 pb-3">
                                <span>#0417</span>
                                <span>18:32 IST</span>
                            </div>
                            <div className="border-t border-dashed border-charcoal/30 pt-3 space-y-1.5">
                                <div className="flex justify-between"><span>1x Butter Chicken</span></div>
                                <div className="flex justify-between"><span>1x Garlic Naan</span></div>
                                <div className="flex justify-between"><span>1x Masala Chai</span></div>
                            </div>
                            <div className="border-t border-dashed border-charcoal/30 mt-3 pt-3 flex justify-between items-center">
                                <span className="text-ember font-semibold">sizzling now</span>
                                <span className="text-charcoal/60">ETA 24 min</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </header>
    )
}
